import { Rocket, BarChart3, Building2, RefreshCw, ArrowLeftRight, LineChart } from "lucide-react";

export interface AdDef {
  id: string;
  title: string;
  tagline: string;
  description: string;
  cta: string;
  url: string;
  icon: typeof Rocket;
  /** CSS custom property name (without --) */
  colorVar: string;
  /** X / Twitter handle (without @) */
  xHandle?: string;
}

export const ads: AdDef[] = [
  {
    id: "lovable",
    title: "Lovable",
    tagline: "Build web apps with AI",
    description: "Get 10 free credits when you sign up!",
    cta: "Try Lovable →",
    url: "https://lovable.dev/invite/F8RZY57",
    icon: Rocket,
    colorVar: "ad-lovable",
    xHandle: "Lovable",
  },
  {
    id: "ibkr",
    title: "Interactive Brokers",
    tagline: "Earn up to $1,000",
    description: "Get up to $1,000 in IBKR stock (NASDAQ: IBKR) when you sign up.",
    cta: "Get started →",
    url: "https://ibkr.com/referral/frederic562",
    icon: Building2,
    colorVar: "ad-ibkr",
    xHandle: "IBKR",
  },
  {
    id: "robinhood",
    title: "Robinhood",
    tagline: "Start trading crypto",
    description: "Get €30 in crypto when you sign up and deposit €20.",
    cta: "Claim €30 →",
    url: "https://join.robinhood.com/eu_crypto/frederv-e2ff6d/",
    icon: BarChart3,
    colorVar: "ad-robinhood",
    xHandle: "RobinhoodApp",
  },
  {
    id: "wise",
    title: "Wise",
    tagline: "Send money abroad",
    description: "Get a free card or zero fees on a transfer up to €500.",
    cta: "Get started →",
    url: "https://wise.com/invite/ihpc/fredericv59",
    icon: ArrowLeftRight,
    colorVar: "ad-wise",
    xHandle: "Wise",
  },
  {
    id: "tradingview",
    title: "TradingView",
    tagline: "Charts & analysis",
    description: "Explore powerful charting tools used by millions of traders.",
    cta: "Try TradingView →",
    url: "https://www.tradingview.com/pricing/?share_your_love=fredericvc&mobileapp=true",
    icon: LineChart,
    colorVar: "ad-tradingview",
    xHandle: "tradingview",
  },
  {
    id: "revolut",
    title: "Revolut",
    tagline: "Join 70M+ users",
    description: "Sign up with my link and join the financial super app.",
    cta: "Join Revolut →",
    url: "https://revolut.com/referral/?referral-code=frederlif0!FEB2-26-AR-H1-RPB-C&geo-redirect",
    icon: RefreshCw,
    colorVar: "ad-revolut",
    xHandle: "RevolutApp",
  },
];
